import axios from 'axios'

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Send httpOnly cookies automatically
})

// Helper to get auth token from LMS localStorage only
function getAuthToken(): string | null {
  // LMS standalone auth token
  return localStorage.getItem('token')
}

// Request interceptor
api.interceptors.request.use((config) => {
  const token = getAuthToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  
  // Add admin 2FA token for admin routes
  const admin2FAToken = localStorage.getItem('admin_2fa_token')
  if (admin2FAToken && config.url?.startsWith('/admin')) {
    config.headers['X-Admin-2FA-Token'] = admin2FAToken
  }
  
  // Remove Content-Type for FormData to let browser set boundary
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type']
  }
  
  return config
})

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear all auth tokens — let the router guard handle redirects for protected routes
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      localStorage.removeItem('admin_2fa_token')
      // Do NOT redirect here — public pages (courses, events, blog) should stay accessible
      // even if an optional API call returns 401. The router.beforeEach guard handles
      // login redirects for routes with meta.requiresAuth.
    }
    // Admin 2FA required (status 499)
    if (error.response?.status === 499) {
      // Emit event for admin 2FA modal
      window.dispatchEvent(new CustomEvent('admin-2fa-required', {
        detail: error.response?.data
      }))
    }
    return Promise.reject(error)
  }
)

export default api
